<template>
    <div class="d-flex flex-column justify-content-center align-items-center">
        <div class="full d-flex flex-column justify-content-center align-items-center">
            <div class="form-group">
                <label for="exampleInputEmail1">Title</label>
                <input type="text" class="form-control" v-model="title">
            </div>
            <div class="form-group">
                <label for="exampleInputEmail1">Color</label>
                <input type="text" class="form-control" v-model="color">
            </div>
            <button type="button" class="btn btn-primary" @click="save">Save changes</button>
        </div>
        <!-- <div class="full margin-top d-flex flex-column justify-content-center align-items-center">
            <h3>Home Image</h3>
            <div class="full d-flex flex-row justify-content-around">
                <button @click="saveUrl(0)">
                    <img :src="urls[0]">
                </button>
                <button @click="saveUrl(1)">
                    <img :src="urls[1]">
                </button>
            </div>
        </div> -->
        <div class="full margin-top d-flex flex-column justify-content-center align-items-center">
            <h3>Logo Image</h3>
            <div class="full d-flex flex-row justify-content-around">
                <button @click="saveLogoUrl(0)">
                    <img :src="logoUrls[0]">
                </button>
                <button @click="saveLogoUrl(1)">
                    <img :src="logoUrls[1]">
                </button>
                <button @click="saveLogoUrl(2)">
                    <img :src="logoUrls[2]">
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import firebase from '@/firebase/init';
export default {
    name: 'startPage',
    data(){
        return{
            urls: ["https://firebasestorage.googleapis.com/v0/b/seven-girls-admin.appspot.com/o/images%2FBitmap1.png?alt=media&token=2e878f93-89a8-4907-987c-fada07a4ee2c",
            "https://firebasestorage.googleapis.com/v0/b/seven-girls-admin.appspot.com/o/images%2FBitmap2.png?alt=media&token=2401338e-1c36-4df8-ac25-f2ea083bed7d"],
            logoUrls: ["https://firebasestorage.googleapis.com/v0/b/seven-girls-admin.appspot.com/o/images%2FPasted_image_at_2019-02-04__7_57_PM.png?alt=media&token=797d7148-7e10-4695-96ed-6ad47511ae5b",
            "https://firebasestorage.googleapis.com/v0/b/seven-girls-admin.appspot.com/o/images%2Fimage.png?alt=media&token=c005518a-2601-461c-9a97-162bc67821fd",
            "https://firebasestorage.googleapis.com/v0/b/seven-girls-admin.appspot.com/o/images%2Fss-app-logo.png?alt=media&token=ed494137-ba9f-48f3-88a8-0fc3bf35a4fa"],
            selectedUrl: null,
            selectedLogoUrl: null,
            title: null,
            color: null

        }
    },
    methods:{
        save(){
            if(this.title && this.color){
                var db = firebase.firestore();
                db.collection("Theme").doc("mainTheme").update({
                    restaurantName: this.title,
                    color: this.color
                })
            }
        },
        saveUrl(index){
            this.selectedUrl = index;
            var db = firebase.firestore();
            db.collection("Theme").doc("mainTheme").update({
                homeImageUrl: this.urls[index]
            })
        },
        saveLogoUrl(index){
            this.selectedLogoUrl = index;
            var db = firebase.firestore();
            db.collection("Theme").doc("mainTheme").update({
                logoUrl: this.logoUrls[index]
            })
        }
    },
    created(){
        var db = firebase.firestore();
        db.collection("Theme").doc("mainTheme").get()
        .then(doc => {
            console.log(doc.data())
            this.title = doc.data().restaurantName;
            this.color = doc.data().color;
        })
    }
}
</script>
<style>
.full{
    width: 40em;
    margin: auto;
}
input{
    width: 40em;
}
img{
    height: 15em;
}
button{
    background-color: transparent;
}
.form-group{
     width: 40em;
     margin-top: 1em;
}
.margin-top{
    margin-top: 3em;
}
.margin-top h3{
    margin-bottom: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/startPage.vue